<template>
  <a-modal :open="open" width="550px" class="strategy__sent-modal" @cancel="handleCancel">
    <div class="sent">
      <h2>¡Apelación enviada a {{ CompanyName }}!</h2>
      <p>
        Tu apelación ha sido enviada y está en proceso de revisión estelar. Nuestro equipo de
        expertos planetarios la evaluará en un tiempo estimado de 1.5 a 2 semanas. ¡Agradecemos tu
        paciencia y confianza!
      </p>
      <img :src="emailMessageImage" alt="Logo de email" />
    </div>
    <template #footer>
      <div class="footer">
        <a-button type="primary" @click="handleSubmit">Aceptar</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script lang="ts" setup>
import { CompanyName } from "@/app/shared/utils/constants";
import emailMessageImage from "@/app/strategies/assets/email-message.png";

defineProps<{ open: boolean }>();

const emit = defineEmits<{ "update:open": [open: boolean] }>();

const handleCancel = (e: MouseEvent) => {
  console.log(e);
  emit("update:open", false);
};

const handleSubmit = (e: MouseEvent) => {
  console.log(e);
  emit("update:open", false);
};
</script>
<style lang="sass" scoped>
h2
  text-align: center
  margin-bottom: 20px
  font-size: 30px
.strategy
  &__sent-modal
    .sent
      padding: 20px
      text-align: center
      img
        margin: 20px
    .footer
      display: flex
      justify-content: center
      button
        padding: 0 30px
</style>
